module.exports = require('./lib/gravatar');



//////////////////
// WEBPACK FOOTER
// ./~/gravatar/index.js
// module id = 92
// module chunks = 1